<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content">
        <div class="box citic-box">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <div class="publish-news-btn">
              <el-button type="primary" @click="handleEdit()">发布新闻</el-button>
            </div>
            <div>
              <el-input class="search" placeholder="按新闻标题搜索" type="text" v-model.trim="keywords" width="10%"></el-input>
              <el-button @click="onSearch" class="btn-search" type="primary">搜索</el-button>
              <el-button @click="onDelete" class="btn-search" type="danger">删除</el-button>
            </div>
            <el-tab-pane label="新闻列表" name="0">
              <news
                  :tableType="tableType"
                  :activeName="activeName"
                  :tableData = "newsList"
                  :tableLabel = "tableLabel"
                  :tableImg = "tableImg"
                  @edit="handleEdit"
                  @delete="handleDelete"
                  @upSort="upSort"
                  @downSort="downSort"
                  @setHot="setHot(arguments)"
              ></news>
              <div class="tip" v-if="newsList.length">
                <div class="load-more-btn" style="text-align: center;" @click="loadMore" v-if="currentPage === newsTotalPages">没有更多数据~~</div>
                <div class="load-more-btn" style="text-align: center;font-size: 18px;cursor: pointer" @click="loadMore" v-else>点击加载更多</div>
              </div>
              <!-- 分页 -->
<!--              <Pagination @currentChange="handlePageChange" :current-page="currentPage" :page-size="pageSize" :total="newsTotal"></Pagination>-->
            </el-tab-pane>
<!--            <el-tab-pane label="历史新闻"name="1">-->
<!--              &lt;!&ndash; 历史新闻 &ndash;&gt;-->
<!--              <news :tableType="tableType" :activeName="activeName" :tableData = "newsList" :tableLabel = "tableLabel" :tableImg = "tableImg" @edit="handleEdit" @delete="handleDelete"></news>-->
<!--              &lt;!&ndash; 分页 &ndash;&gt;-->
<!--              <Pagination @current-change="handlePageChange" :current-page="currentPage" :page-size="pageSize" :total="newsTotal"></Pagination>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="热门新闻设置" name="2">-->
<!--              &lt;!&ndash; 热门新闻设置 &ndash;&gt;-->
<!--              <news :activeName="activeName" :tableData = "newsList" :tableLabel = "tableLabel" :tableImg = "tableImg" @edit="handleEdit" @delete="handleDelete"></news>-->
<!--              &lt;!&ndash; 分页 &ndash;&gt;-->
<!--              <Pagination @current-change="handlePageChangeThree" :current-page="currentPage" :page-size="pageSize" :total="newsTotal"></Pagination>-->
<!--            </el-tab-pane>-->
          </el-tabs>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import TheSearchBox from '../../widgets/widgetSearchBox'
import News from '../../widgets/widghtNews'
import Pagination from '../../widgets/widghtPagination'

export default {
  name: 'PostHome',
  components: {
    TheSearchBox,
    News,
    Pagination
  },
  data () {
    return {
      newsList: [],
      tableImg: [
        {
          prop: 'head_images',
          label: '新闻头图'
        }
      ], // 表格header
      tableLabel: [
        {
          prop: 'TITLE',
          label: '新闻标题'
        },
        {
          prop: 'CONTENT',
          label: '新闻内容'
        },
        {
          prop: 'CREATETIME',
          label: '发布时间'
        }
      ], // 表格header
      activeName: '0', // 当前活跃的tabbar 0 表示当日新闻/1 表示历史新闻/2 表示设置热门新闻
      currentPage: 1,
      newsTotal: 0, // 新闻总数
      newsTotalPages: 0, // 当日新闻总页数
      pageSize: 10, // 每页显示的新闻数
      loading: false,
      keywords: '',
      tableType: 'news' // 来控制表格显示什么内容
    }
  },
  methods: {
    // 编辑新闻跳转
    handleEdit (id) {
      /*
      * 两种情况：
      * 1、发布新闻(没有newsId)
      * 2、编辑新闻(有newsId)
      * */
      if (id) {
        this.$router.push(`/news/edit/${id}`)
      } else {
        this.$router.push(`/news/add`)
      }
    },
    // 搜索回车/虚拟操作键盘搜索
    onSearch () {
      let keys = this.keywords
      this.fetchNewsData({
        keys: keys,
        page: 1
      })
    },
    // 删除搜索内容
    onDelete () {
      this.keywords = ''
      this.fetchNewsData({
        keys: '',
        page: 1
      })
    },
    // tab切换
    handleClick (tab, event) {
      // console.log(this.activeName)
      // console.log(tab, event)
    },
    // 页面分页
    handlePageChange (page) {
      this.currentPage = page
      this.fetchNewsData({
        keys: this.keywords,
        page: Number(this.currentPage)
      })
    },
    // 加载更多
    loadMore () {
      if (this.currentPage >= this.newsTotalPages) return
      this.currentPage += 1
      let url = this.$config.API.news.list
      axios.post(url, {
        keys: this.keywords,
        page: Number(this.currentPage)
      }).then(res => {
        if (res.status === 200 && res.data.result === 'success') {
          this.newsList = this.newsList.concat(res.data.sjhnewsList)
          this.newsTotal = res.data.total // 总条数
          this.newsTotalPages = res.data.total_page // 总页数
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取新闻列表
    fetchNewsData (params) {
      let url = this.$config.API.news.list
      axios.post(url, params).then(res => {
        if (res.status === 200 && res.data.result === 'success') {
          this.newsList = res.data.sjhnewsList
          this.newsTotal = res.data.total // 总条数
          this.newsTotalPages = res.data.total_page // 总页数
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 删除新闻
    handleDelete (newsId) {
      let url = this.$config.API.news.delete
      let params = {
        news_id: newsId
      }
      this.$confirm('要删除该条新闻吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post(url, params).then(res => {
          if (res.status === 200 && res.data.result === 'success') {
            this.newsList = this.newsList.filter(item => {
              return item.ID !== newsId
            })
            this.$message({
              type: 'info',
              message: '已删除'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 向上排序
    upSort (newsId) {
      // 获取newsId在数组中位置
      let index = this.newsList.findIndex(item => {
        return item.ID === newsId
      })
      // 获取到上一条新闻的ID
      let prevNewsId = this.newsList[index - 1].ID
      let params = {
        up_news_id: prevNewsId,
        down_news_id: newsId
      }
      let url = this.$config.API.news.sort
      axios.get(url, {params}).then(res => {
        if (res.status === 200 && res.data.result === 'success') {
          // 上移
          this.newsList.splice(index - 1, 1, ...this.newsList.splice(index, 1, this.newsList[index - 1]))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 向下排序
    downSort (newsId) {
      // 获取newsId在数组中位置
      let index = this.newsList.findIndex(item => {
        return item.ID === newsId
      })
      // 获取到下一条新闻的ID
      let nextNewsId = this.newsList[index + 1].ID
      let params = {
        up_news_id: newsId,
        down_news_id: nextNewsId
      }
      let url = this.$config.API.news.sort
      axios.get(url, {params}).then(res => {
        if (res.status === 200 && res.data.result === 'success') {
          // 下移
          this.newsList.splice(index, 1, ...this.newsList.splice(index + 1, 1, this.newsList[index]))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 设置热门
    setHot (args) {
      let url = this.$config.API.news.setHot
      let params = {
        news_id: args[0],
        ishot: args[1] === '1' ? '0' : '1'
      }
      axios.post(url, params).then(res => {
        if (res.status === 200 && res.data.result === 'success') {
          let index = this.newsList.findIndex(item => {
            return item.ID === args[0]
          })
          this.newsList[index]['ISHOT'] = params.ishot
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    this.fetchNewsData({
      keys: '',
      page: this.currentPage
    })
  }
}
</script>
<style lang="scss">
.publish-news-btn{
  margin-bottom: 20px;
}
.citic-box {
  padding-top: 15px;
  .el-tabs__content {
    overflow: visible !important;
    position: static;
  }
  .box-header {
    ul.nav-tabs {
      margin-bottom: 0 !important;
      border-bottom: 0;
      li > a {
        color: #9ebbcd !important;
      }
      li.active > a {
        color: #333 !important;
      }
    }
  }
  .search {
    width: 80%;
    margin-bottom: 20px;
  }
  .btn-search {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// news.vue?131f796b